import React, { memo } from 'react';

import Icon from '../../icons/Icon';
import { ICONS } from '../../icons';

import './EyeButton.scss';

const EyeButton = ({ onClick, isActive }) => {
  return (
    <button className='btn-visible' onClick={onClick}>
      {isActive ? <Icon icon={ICONS.EyeCrossed} disableCommonColors /> : <Icon icon={ICONS.Eye} disableCommonColors />}
    </button>
  );
};

export default memo(EyeButton);
